import React, { createContext, useContext, useState, useEffect } from 'react';

const BattleModeContext = createContext();

export const useBattleMode = () => {
  const context = useContext(BattleModeContext);
  if (!context) {
    throw new Error('useBattleMode must be used within a BattleModeProvider');
  }
  return context;
};

export const BattleModeProvider = ({ children }) => {
  const [isBattleMode, setIsBattleMode] = useState(false);
  
  useEffect(() => {
    if (isBattleMode) {
      console.log('⚔️ BATTLE MODE ACTIVATED - All non-essential features paused');
    } else {
      console.log('🏠 BATTLE MODE DEACTIVATED - Normal app features resumed');
    }
  }, [isBattleMode]);

  const enableBattleMode = () => {
    console.log('🎮 Enabling Battle Mode...');
    setIsBattleMode(true);
  };

  const disableBattleMode = () => {
    console.log('🏠 Disabling Battle Mode...');
    setIsBattleMode(false);
  };

  return (
    <BattleModeContext.Provider value={{ isBattleMode, enableBattleMode, disableBattleMode }}>
      {children}
    </BattleModeContext.Provider>
  );
};
